/**
 * Every variant selector block stores its Contentstack settings the same way:
 * the fields all selectors share (label, modal, option) sit on the referenced
 * entry, and the fields specific to one selector type sit in the first modular
 * block, keyed by that type.
 */
export function readSelectorSettings(block) {
  const settings = block?.variant_selector?.reference?.[0] ?? {};
  const [selectorType, selectorSettings] =
    Object.entries(settings.modular_blocks?.[0] ?? {})[0] ?? [];

  return {
    selectorType, // e.g. button_grid, column, dropdown, swatches
    settings, // the fields all selectors share (label, modal, option)
    selectorSettings: selectorSettings ?? {} // selector type specific settings
  };
}

/**
 * The Shopify option a selector controls. Contentstack stores the option by
 * name, so it can point at something the product doesn't have.
 *
 * @param blockLabel how to name this block in the error, e.g. 'button grid'.
 */
export function findSelectorOption(productData, optionName, blockLabel) {
  const option = productData?.shopifyProduct?.options?.find(
    (o) => o?.name === optionName
  );

  if (!option) {
    console.error(
      `No matching variant option found for "${optionName}" ${blockLabel}.`
    );
    return null;
  }

  return option;
}
